import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        jdmn.log("event_resize.js initialized", "green");

        var isResizing = false;
        var resizeTimer;
        var delay = 250;

        $(window).on("resize", function () {
            if (!isResizing) {
                isResizing = true;
                $(window).trigger("resizeStart");
            }

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
                isResizing = false;
                $(window).trigger("resizeEnd");
            }, delay);
        });
    });
})();
